/****  SOMA MENU LOGIC  ****/

  document.addEventListener('DOMContentLoaded', function() {
    // Select all <details> inside menu drawer
    const accordions = document.querySelectorAll('.menu-drawer__menu details');

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector('summary');

      summary.addEventListener('click', function(e) {
        // Delay to allow <details> to toggle open state
        setTimeout(() => {
          if (accordion.open) {
            // Close all other accordions
            accordions.forEach((other) => {
              if (other !== accordion) {
                other.removeAttribute('open');
              }
            });
          }
        }, 0);
      });

      


    });
  });

